export const INPUT_SIZE = ['small', 'medium', 'large'] as const

export const INPUT_CONTAINER = 'INPUT_CONTAINER'
